import "../../styles/common/pageHeader.css";

const PageHeader = ({ title, description, action }) => {
  return (
    <section className="page-header">
      <h1 className="page-title">{title}</h1>

      {description && <p className="page-subtitle">{description}</p>}
      {action && <div className="page-header-action">{action}</div>}
    </section>
  );
};

export default PageHeader;
